// Client for the Shape inbound lead provider (Lender.Optimus.Integrations). Intake-token
// lifecycle, the immutable inbound-lead run log, and lead-spend aggregates all live under
// /api/integration-studio/lead-providers/shape. Provider enable/disable + SettingsJson persist
// through the shared provider-configuration endpoints on integrationStudioApi (providerKey
// `shape`) — kept there so this module is the single place a lead-provider route change lands.

const BASE = '/api/integration-studio/lead-providers/shape';

export class ShapeLeadProviderApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  // --- Intake tokens (plaintext token returned once, on mint only) ---

  async getTokens() {
    return this.#http.get(`${BASE}/tokens`);
  }

  async mintToken() {
    return this.#http.post(`${BASE}/tokens`);
  }

  async revokeToken(tokenId) {
    return this.#http.post(`${BASE}/tokens/${tokenId}/revoke`);
  }

  // --- Inbound leads (immutable run history) ---

  async getInboundLeads(params) {
    return this.#http.get(`${BASE}/inbound-leads`, { params });
  }

  async getInboundLead(id) {
    return this.#http.get(`${BASE}/inbound-leads/${id}`);
  }

  async replayInboundLead(id) {
    return this.#http.post(`${BASE}/inbound-leads/${id}/replay`);
  }

  async getAggregates(params) {
    return this.#http.get(`${BASE}/inbound-leads/aggregates`, { params });
  }
}
